<template>
  <section class="flex flex-1 flex-col overflow-hidden p-1">
    <TownToShimmer
      v-if="townsToQuery.isLoading.value || townsToQuery.isFetching.value"
      class="flex-1"
    />

    <UiErrorCard
      v-else-if="townsToQuery.isError.value"
      class="m-2 px-2 py-4"
      @onReload="townsToQuery.refetch"
    />

    <TownsToList
      v-else-if="townsToQuery.data.value"
      :key="selectedCountryToId"
      :towns-to="townsToQuery.data.value"
      :initial-towns-to="props.initialTownsTo"
      @onTownsToChange="$emit('onTownsToChange', $event)"
    />
  </section>
</template>

<script lang="ts" setup>
  import { computed, watch } from 'vue';
  import type { Tourflow } from '@aviata/platform-types';

  import { UiErrorCard } from '@shared/ui';
  import { useTownsToQuery } from '@entities/towns-to';

  import TownToShimmer from './TownToShimmer.vue';
  import TownsToList from './TownsToList.vue';

  const props = defineProps<{
    townFromId: number;
    selectedCountryToId: number;
    initialTownsTo: Tourflow.TownTo[] | null;
  }>();

  const emit = defineEmits<{
    onTownsToChange: [towns: Tourflow.TownTo[] | null];
    onSkipTownsToStep: [];
  }>();

  /**
   * @description we pass the prop to `computed` to make it reactive
   * Prop should be reactive, so queries below will refetch the data
   * and it will be up-to-date
   */
  const townsToQuery = useTownsToQuery(
    computed(() => props.selectedCountryToId),
    computed(() => props.townFromId),
  );

  watch(townsToQuery.data, value => {
    if (value && value.length === 1) {
      emit('onSkipTownsToStep');
    }
  });
</script>
